var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      (_vm.institution && !_vm.institution.kl_assessment) ||
      (_vm.user && _vm.user.groups.includes(7))
    )?[_c('Page404')]:[_c('RubricPreset',{attrs:{"allows_crud":_vm.allows_crud}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }